import request from "@/utils/request";

// 查询工单工作台-cc列表
export async function listMesDiscreteJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/list',
    method: 'post',
    data
  })
}

// 查询工单用料-cc列表
export async function apiRequirementOperationsCcList (data) {
  return request({
    url: '/mes/mesRequirementOperationsCc/list',
    method: 'post',
    data
  })
}

// 查询关联工单-cc列表
export async function apiAssociatedWorkOrderList (params) {
  return request({
    url: '/mes/mesDiscreteJobsCc/associatedWorkOrderList',
    method: 'post',
    data: params
  })
}

// 查询工单工作台-cc详细
export async function getMesDiscreteJobsCc (id) {
  return request({
    url: '/mes/mesDiscreteJobsCc/' + id,
    method: 'get'
  })
}

// 新增工单工作台-cc维护
export async function addMesDiscreteJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/add',
    method: 'post',
    data
  })
}

// 修改工单工作台-cc维护
export async function updateMesDiscreteJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/edit',
    method: 'post',
    data
  })
}

// 批量修改工单工作台-cc维护
export async function apiBatchUUpdateMesDiscreteJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/batchEdit',
    method: 'post',
    data
  })
}

// 导出工单工作台-cc维护
export async function apiExportMesDiscreteJobsCc (params) {
  return request({
    url: '/mes/mesDiscreteJobsCc/export',
    method: 'post',
    data: params
  })
}

// 导出关联工单-cc维护
export async function apiExportAssociatedWorkOrder (params) {
  return request({
    url: '/mes/mesDiscreteJobsCc/exportAssociatedWorkOrder',
    method: 'post',
    data: params
  })
}

// 导出用料表-cc维护
export async function apiExportRequirementOperationsCc (params) {
  return request({
    url: '/mes/mesRequirementOperationsCc/export',
    method: 'post',
    data: params
  })
}

// 导入工单工作台-cc日志
export async function getMesDiscreteJobsCcLogApi (params) {
  return request({
    url: '/mes/mesWipLog/selectMesWipCommonLogs',
    method: 'get',
    params
  })
}

// 合单领料申请
export function apiMergeMaterialRequisition (data) {
  return request({
    url: '/mes/mesDiscreteJobsCcMo/mergeMaterialRequisition',
    method: 'post',
    data: data
  })
}

// 关闭工单工作台-cc维护
export function apiCloseMesDiscreteJobsCcLog (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/batchClose',
    method: 'post',
    data: data
  })
}
// 排产-拆单排产获取信息
export function apiGetConfirmScheduleMesDiscreteJobsCcInfo (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/getSplitOrderPcInfo',
    method: 'get',
    params: data
  })
}

// 排产-确认排产
export function apiConfirmScheduleMesDiscreteJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/confirmProductionScheduling',
    method: 'post',
    data: data
  })
}
// 排产-确认发布
export function apiPublishScheduleMesDiscreteJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/confirmPublish',
    method: 'post',
    data: data
  })
}

// 拆单排产-确认排产
export function apiSplitOrderConfirmPc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/splitOrderConfirmPc',
    method: 'post',
    data: data
  })
}
// 拆单排产-确认发布
export function apiSplitOrderConfirmPublish (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/splitOrderConfirmPublish',
    method: 'post',
    data: data
  })
}

// 发布
export function apiPublishMesDiscreteJobsCcBill (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/publish',
    method: 'post',
    data: data
  })
}

// 发布
export function apiCancelMesDiscreteJobsCcBill (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/cancel',
    method: 'post',
    data: data
  })
}

// 派工
export function apiDispatchMesDiscreteJobsCcBill (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/dispatch',
    method: 'post',
    data: data
  })
}

// 撤销派工
export function apiRevokeDispatchMesDiscreteJobsCcBill (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/revokeDispatch',
    method: 'post',
    data: data
  })
}

// 撤掉发布
export function apiRevokePublishMesDiscreteJobsCcBill (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/revokePublish',
    method: 'post',
    data: data
  })
}

// 领料-新增
export function apiConfirmAddRequisitionJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/addRequisition',
    method: 'post',
    data: data
  })
}
// 领料-确认派工
export function apiConfirmDispatchRequisitionJobsCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/addRequisitionDispatch',
    method: 'post',
    data: data
  })
}
// CC工单拆解
export function apiCcDiscreteJobsDisassembly (data) {
  return request({
    url: '/mes/mesDiscreteJobs/ccDiscreteJobsDisassembly',
    method: 'post',
    data: data
  })
}

// 根据工单用料ID获取发起的物料信息
export function apiCcGetMaterialInfoByRequirementIds (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/getMaterialInfoByRequirementIds',
    method: 'post',
    data: data
  })
}

// 提交物料变更流程审批
export function apiCcSubmitChangeItem (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/submitChangeItem',
    method: 'post',
    data: data
  })
}

// 获取班组排班对应的班组
export function apiGetBomTeamScheduleCcList (params) {
  return request({
    url: '/bom/team/schedule/list',
    method: 'get',
    params
  })
}

// 获取工作中心对应的班组
export function apiGetBomTeam (params) {
  return request({
    url: '/bom/team/list',
    method: 'get',
    params
  })
}

// 联动上级工单时间
export function apiLinkageSuperTimeCc (data) {
  return request({
    url: '/mes/mesDiscreteJobsCc/linkageSuperTime',
    method: 'POST',
    data
  })
}
